import styled, { css } from 'styled-components';

import { mediaQuery } from '@catalyze/ui';

export const RealEstateListPageContainer = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    padding-top: 0rem;
    margin-bottom: 50px;
    ${mediaQuery(
        2,
        css`
            padding-top: 0rem;
        `
    )}
`;
